import styled from "styled-components";

export const TableCaption = styled.p`
  margin: 0.25rem 0 0 0;
`;
